var React = require('react');

function IconQuestionMarkCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M511.3 62.3c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm25.8 705.5h-53.8c-2.2 0-4-1.8-4-4v-52.7c0-2.2 1.8-4 4-4h57.8v56.7c0 2.2-1.8 4-4 4zm68.7-246.4c-43.8 40-65.6 75.2-65.6 105.6v21.7c0 2.2-1.8 4-4 4h-51.9c-2.2 0-4-1.8-4-4v-36c0-34.2 21.9-73.2 65.6-117 38-38 59-69.4 62.8-94.2-3.8-49.5-30.5-77.1-79.9-82.8-78.6-3.7-117.6 32.9-117.1 110.2 0 2.2-1.8 4-4 4H353c-2.2 0-4-1.8-4-4-.6-117.2 56.5-174.8 171.2-173 100.8 3.8 153.1 52.4 157 145.6-.1 36.2-23.9 76.2-71.4 119.9z"}));
}

IconQuestionMarkCircleSolid.displayName = "IconQuestionMarkCircleSolid";

IconQuestionMarkCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconQuestionMarkCircleSolid;

IconQuestionMarkCircleSolid.default = IconQuestionMarkCircleSolid;
